import * as React from "react";
const SVGComponentFooterChats = (props) => (
  <svg
    height="200px"
    width="200px"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
    {...props}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <g>
        <path
          style={{
            fill: "#222b63",
          }}
          d="M383.147,158.025c-7.717,0-13.975-6.258-13.975-13.975v-6.044 c0-62.742-48.654-110.057-113.173-110.057c-64.518,0-113.17,47.313-113.17,110.057v6.044c0,7.717-6.258,13.975-13.975,13.975 c-7.717,0-13.975-6.258-13.975-13.975v-6.044c0-37.949,14.643-72.992,41.227-98.675C182.36,13.968,217.835,0,255.999,0 s73.639,13.968,99.894,39.33c26.586,25.684,41.229,60.728,41.229,98.677v6.044C397.122,151.769,390.864,158.025,383.147,158.025z"
        />
        <path
          style={{
            fill: "#222b63",
          }}
          d="M267.431,512h-61.29c-7.717,0-13.975-6.258-13.975-13.975s6.258-13.975,13.975-13.975h61.29 c8.093,0,14.676-6.585,14.676-14.678c0-8.093-6.584-14.678-14.676-14.678h-32.173c-7.717,0-13.975-6.258-13.975-13.975 c0-7.717,6.258-13.975,13.975-13.975h32.173c23.503,0,42.626,19.123,42.626,42.628S290.935,512,267.431,512z"
        />
        <path
          style={{
            fill: "#222b63",
          }}
          d="M242.135,454.694h-34.378c-23.504,0-42.628-19.123-42.628-42.628s19.123-42.628,42.628-42.628 c0.084,0,0.166,0.001,0.25,0.003l31.963,0.569c1.139-0.034,2.056-0.971,2.056-2.12v-13.377c0-3.464-2.214-6.511-5.509-7.581 c-0.324-0.105-0.646-0.222-0.961-0.351l-54.698-22.308c-7.147-2.915-10.576-11.071-7.662-18.218 c2.915-7.145,11.072-10.576,18.218-7.662l54.28,22.139c14.549,4.978,24.283,18.56,24.283,33.981v13.377 c0,16.581-13.489,30.071-30.071,30.071c-0.084,0-0.166-0.001-0.25-0.003l-32-0.57c-8.047,0.056-14.576,6.618-14.576,14.678 c0,8.093,6.585,14.678,14.678,14.678h34.378c7.717,0,13.975,6.258,13.975,13.975S249.852,454.694,242.135,454.694z"
        />
        <path
          style={{
            fill: "#222b63",
          }}
          d="M256.001,368.49c-7.717,0-13.975-6.258-13.975-13.975c0-15.421,9.734-29.005,24.283-33.981 l54.288-22.142c7.148-2.915,15.303,0.516,18.218,7.662c2.914,7.147-0.516,15.303-7.662,18.218l-54.706,22.311 c-0.317,0.129-0.636,0.246-0.961,0.351c-3.295,1.07-5.509,4.117-5.509,7.581C269.976,362.232,263.718,368.49,256.001,368.49z"
        />
      </g>
      <path
        style={{
          fill: "#785af0",
        }}
        d="M123.791,150.317c-15.934,0-29.015,12.2-30.423,27.77c-10.158,2.254-17.819,11.35-17.819,22.161 v24.456c0,10.811,7.661,19.907,17.819,22.16c1.409,15.569,14.489,27.77,30.423,27.77c16.875,0,30.559-13.68,30.559-30.555v-63.206 C154.35,163.997,140.667,150.317,123.791,150.317z"
      />
      <path
        style={{
          fill: "#222b63",
        }}
        d="M123.791,288.61c-20.06,0-37.032-13.022-42.598-31.478c-11.768-6.252-19.618-18.694-19.618-32.426 v-24.456c0-13.733,7.851-26.175,19.618-32.427c5.568-18.454,22.54-31.477,42.598-31.477c24.555,0,44.534,19.976,44.534,44.53v63.207 C168.325,268.634,148.346,288.61,123.791,288.61z M123.791,164.293c-8.491,0-15.741,6.612-16.506,15.054 c-0.548,6.058-4.953,11.067-10.891,12.383c-3.983,0.883-6.871,4.465-6.871,8.518v24.456c0,4.051,2.89,7.634,6.873,8.518 c5.938,1.318,10.341,6.325,10.889,12.383c0.764,8.442,8.013,15.054,16.506,15.054c9.145,0,16.584-7.437,16.584-16.58v-63.207 C140.375,171.731,132.936,164.293,123.791,164.293z"
      />
      <path
        style={{
          fill: "#785af0",
        }}
        d="M388.209,150.317c15.934,0,29.015,12.2,30.423,27.77c10.158,2.254,17.819,11.35,17.819,22.161v24.456 c0,10.811-7.661,19.907-17.819,22.16c-1.409,15.569-14.489,27.77-30.423,27.77c-16.875,0-30.559-13.68-30.559-30.555v-63.206 C357.65,163.997,371.333,150.317,388.209,150.317z"
      />
      <path
        style={{
          fill: "#222b63",
        }}
        d="M388.209,288.61c-24.555,0-44.534-19.976-44.534-44.53v-63.207c0-24.554,19.978-44.53,44.534-44.53 c20.06,0,37.031,13.023,42.598,31.477c11.767,6.252,19.618,18.694,19.618,32.427v24.456c0,13.732-7.85,26.174-19.618,32.426 C425.241,275.587,408.27,288.61,388.209,288.61z M388.209,164.293c-9.145,0-16.584,7.437-16.584,16.58v63.207 c0,9.142,7.439,16.58,16.584,16.58c8.491,0,15.741-6.612,16.506-15.054c0.548-6.058,4.951-11.065,10.889-12.383 c3.983-0.883,6.873-4.465,6.873-8.518v-24.456c0-4.051-2.889-7.634-6.871-8.518c-5.938-1.316-10.343-6.325-10.891-12.383 C403.95,170.905,396.7,164.293,388.209,164.293z"
      />
    </g>
  </svg>
);
export default SVGComponentFooterChats;
